'use server';

import { headers } from "next/headers";
import { getSettings } from "@/lib/settings";
import { encryptPayload } from "@/lib/encryption";

export async function createStatelessSessionAction(data: any) {

    try {
        const headersList = await headers();
        const hostname = headersList.get("x-forwarded-host") || headersList.get("host") || "";
        const domain = hostname.split(":")[0];
        const settings = await getSettings(domain);

        if (!settings || !settings.siteId) {
            return { success: false, error: "Sistem yapılandırma hatası." };
        }

        // 10 dakikalık , acentenin siteId'si ile crypt
        const encryptedToken = encryptPayload(data, settings.siteId, 10);

        if (!encryptedToken) {
            return { success: false, error: "Güvenlik token'ı oluşturulamadı." };
        }

        return { success: true, token: encryptedToken };
    } catch (error: any) {
        return { success: false, error: error.message || "İşlem başlatılamadı." };
    }
}